import isEqual from 'lodash/isEqual';

import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {RelativeDateRange} from 'common/widgets/date-range-picker/models/relative-date-range';
import {BaseDate, DateRangeType, RelativeDate} from 'common/widgets/date-range-picker/models/types';

import {ComparisonDate, ComparisonDateRangeBookmarkFormat} from './types';

export function getRelativeDateFromComparisonDate(comparisonDate: ComparisonDate): RelativeDate {
  const date: BaseDate = comparisonDate.offset ?? comparisonDate.from ?? comparisonDate.to;
  if (DateRange.isRelativeDate(date)) {
    return date;
  }

  return DateRange.convertCalendarDateToRelativeDate(date);
}

export function getComparisonType(comparisonDate?: ComparisonDate) {
  //DateRangeType.EndsOn has a to date. Otherwise, it's StartsOn
  if (comparisonDate?.to) {
    return DateRangeType.EndsOn;
  }
  return DateRangeType.StartsOn;
}

export function getPresetMatch(comparisonDate?: ComparisonDate) {
  if (!comparisonDate?.offset) {
    return null;
  }
  return RelativeDateRange.getTimeComparisonPresetOptions().find((option) =>
    isEqual(comparisonDate, {offset: option.value.offset}),
  );
}

// Why did we use from/to instead of from_date/to_date ?
export function comparisonDateToBookmarkFormat(comparisonDate: ComparisonDate): ComparisonDateRangeBookmarkFormat {
  const {from, offset, to} = comparisonDate;
  return {
    ...(from ? {from_date: from} : {}),
    ...(offset ? {offset} : {}),
    ...(to ? {to_date: to} : {}),
  };
}

export function comparisonDateFromBookmarkFormat(
  bookmarkComparisonDate: ComparisonDateRangeBookmarkFormat,
): ComparisonDate {
  const {from_date: from, offset, to_date: to} = bookmarkComparisonDate;
  if (offset) {
    return {offset};
  } else if (from || to) {
    return {
      ...(from ? {from} : {}),
      ...(to ? {to} : {}),
    };
  }
  return null;
}
